export interface AppTitleProps {
    tenant_slug: string;
    venue_slug: string
    venue_name: string
}

const AppTitle = (props: AppTitleProps) => {
    return (
        <div class="flex items-center gap-4">
            <img src={`/api/recording/${props.tenant_slug || ''}/venues/${props.venue_slug || ''}/logo`} alt="Venue logo" class="h-12 w-12 rounded-full" />
            <div class="leading-tight">
                <div class="text-purple-500 text-sm font-semibold">TapSafe</div>
                <div class="text-lg font-bold">{props.venue_name}</div>
            </div>
        </div>
    )
}

export default AppTitle